import React, { useRef, useState } from "react";
import { Row } from "react-bootstrap";
import LAlert from "components/LAlert";
import useWindowSize from "core/hooks/useWindowSize";
import {
  CreateSupllier,
  UpdateSupplier,
  UpdateUser,
  ValidationEmailSendCode,
  ValidationEmailValidateCode,
} from "../service/landingPage.service";
import { pricing } from "../data/pricing";
import { hideLoading, showLoading } from "components/LLoading";
import "../style.css";
import Access from "./Access";
import CheckEmail from "./CheckEmail";
import { EPaymentMethod, useLandingPageContext } from "pages/Context/LandinPageContext";
import Payment from "./Payment";
import { encryptData } from "core/functions/crypto";
import PaymentWithSuccess from "./PaymentWithSuccess";
import { supplierRegistrationSchema } from "../validations/supplierRegistration";
import { CreatePix, IPaymentPixResponse, IPaymentTicketLicitem, IPaymentTicketLicitemResponse } from "../service/payment.service";
import { LTMTransactionStatus } from "core/enums/transaction";
import { monitorTransaction } from "core/functions/monitorTransaction";
import { IPeriodicTime } from "core/enums/plans.enum";

const Register = () => {
  const { width } = useWindowSize();
  const ref = useRef(null);

  const [errorMessage, setErrorMessage] = useState("");
  const [selectedPriceId, setSelectedPriceId] = useState<number | null>(5);
  const [startIndex, setStartIndex] = useState(0);
  const { selectedPlanContext, supplierDataContext,setSupplierDataContext, currentStepContext, setCurrentStepContext, setIsManualPaymentContext } = useLandingPageContext();

  // Gateway caiu no fluxo manual: avança pro sucesso marcando como manual.
  const handleManualPayment = () => {
    setIsManualPaymentContext(true);
    setCurrentStepContext(4);
  };
  const [initialValues, setInitialValues] = useState({
    nameUser: "",
    cpf: "",
    name: "",
    cnpj: "",
    email: "",
    fantasyName: "",
    password: "",
    confirmPassword: "",
  });

  const data: IPaymentTicketLicitem = {
    planId: selectedPlanContext?._id || "",
    supplierId: supplierDataContext?.idSupplier ?? "",
    installmentsNumber: 1,
    isCnpjUsed:false,
  };


  const handleSubmitPix = async () => {
    showLoading();
    setIsManualPaymentContext(false);

    try {
      let response: IPaymentPixResponse | IPaymentTicketLicitemResponse | any;
    
      response = await CreatePix(data);

      if (response?.paymentStatus === LTMTransactionStatus.APPROVED) {
        setCurrentStepContext(4);
      }

      if (response?.paymentStatus === LTMTransactionStatus.GATEWAY_FAILED) {
        handleManualPayment();
      }

      if (response?.paymentStatus === LTMTransactionStatus.PENDING) {
        await monitorTransaction(response._id, false, EPaymentMethod.PIX, setCurrentStepContext, handleManualPayment);
      }

    } catch (err) {
      LAlert({description: `${err}`});
    } finally {
      hideLoading();
    }
  };

  const handleSubmit = async (values: any, { setSubmitting }: any) => {
    showLoading();

    if (currentStepContext === 1) {
      setInitialValues(values);
      const data = { email: values.email };
      const dataCreateSupplier: any = {
        nameUser: values.nameUser,
        cpf: values.cpf,
        cnpj: values.cnpj,
        phone: values.phone.replace(/[()\-\s]/g, ""),
        socialReason: values.name,
        fantasyName: values.fantasyName,
        email: values.email,
        password: values.password,
      };

      // const login = async () => {
      //   const response = await axiosDefault.login(values.email, values.password);
      //   localStorage.setItem("token", encryptData(response.access_token));
      // };

      try {
        let response;
        if (supplierDataContext && supplierDataContext.idSupplier) {
          response = await UpdateSupplier(supplierDataContext.idSupplier, dataCreateSupplier);
          await UpdateUser(supplierDataContext.idUser, { email: values.email });
        } else {
          response = await CreateSupllier(dataCreateSupplier);
          setSupplierDataContext(response);
          localStorage.setItem("token", encryptData(response.accessToken));
        }
        await ValidationEmailSendCode(data);
        handleNextStep();
      } catch (error: any) {
        hideLoading();
        LAlert({
          variant: "warning",
          description: `${supplierDataContext?.idSupplier ? error : error}`,
        });
      } finally {
        hideLoading();
      }
    }

    if (currentStepContext === 2) {
      const dataEmail = {
        email: initialValues.email,
        code: values.verificationCode,
      };
      try {
        await ValidationEmailValidateCode(dataEmail);
        if(selectedPlanContext?.period.type === IPeriodicTime.FREE) await handleSubmitPix();
        if(selectedPlanContext?.period.type !== IPeriodicTime.FREE ) handleNextStep();
        // await login();
      } catch (error: any) {
        if (error.status === 400) {
          setErrorMessage("Código errado");
        } else {
          LAlert({ variant: "warning", description: `${error}` });
        }
        hideLoading();
      } finally {
        hideLoading();
      }
    }

    hideLoading();
    setSubmitting(false);
  };

  const handleNextStep = () => setCurrentStepContext((prevStep) => prevStep + 1);
  const handlePrevStep = () => setCurrentStepContext((prevStep) => prevStep - 1);

  const handleResendCode = async () => {
    const data = { email: initialValues.email };
    try {
      showLoading();
      await ValidationEmailSendCode(data);
      LAlert({
        variant: "success",
        description: "Código de verificação reenviado com sucesso.",
      });
    } catch (error: any) {
      hideLoading();
      LAlert({
        variant: "warning",
        description: `${error}`,
      });
    } finally {
      hideLoading();
    }
  };

  const handleVerificationCodeChange = () => setErrorMessage("");
  const handleSelectPrice = (id: any) => setSelectedPriceId(id);

  // Controle do carrossel para exibição dos preços
  const handlePrev = () => setStartIndex((prev) => (prev > 0 ? prev - 1 : prev));
  const handleNext = () => setStartIndex((prev) => (prev < pricing.length - 1 ? prev + 1 : prev));

  const itemsToShow = width < 480 ? 1 : width < 776 ? 2 : 3;
  const displayedItems = pricing.slice(startIndex, startIndex + itemsToShow);
  const selectedPrice = pricing.find((price) => price.id === selectedPlanContext?._id);

  return (
    <div className="w-100" id="register-form">
      <div className="d-flex flex-column align-items-center position-relative bg-white" style={{ minHeight: "80vh", padding: "60px 0 60px 0" }}>
        <h5 className="text-1xl sm:text-2xl font-semibold text-gray-800 mb-4">
          {`${(currentStepContext <= 2 || selectedPlanContext?.period.type === IPeriodicTime.FREE) ? "Cadastrar-se" : "Pagamento"}`}
        </h5>
        <div className="w-100 d-flex flex-column justify-content-center container p-0 m-0">
          <Row className="justify-content-center">
            {currentStepContext === 1 && (
              <Access initialValues={initialValues} Schema={supplierRegistrationSchema} handleSubmit={handleSubmit} idSupplier={supplierDataContext?.idSupplier} />
            )}
            {currentStepContext === 2 && (
              <CheckEmail
                email={initialValues.email}
                handleSubmit={handleSubmit}
                handleVerificationCodeChange={handleVerificationCodeChange}
                handleResendCode={handleResendCode}
                errorMessage={errorMessage}
                handlePrevStep={handlePrevStep}
              />
            )}
            {currentStepContext === 3 && (
              <Payment
                pricing={pricing}
                selectedPriceId={selectedPriceId}
                handleSelectPrice={handleSelectPrice}
                displayedItems={displayedItems}
                handlePrev={handlePrev}
                handleNext={handleNext}
                startIndex={startIndex}
                itemsToShow={itemsToShow}
                selectedPrice={selectedPrice}
                ref={ref}
              />
            )}
            {currentStepContext === 4 && (
              <PaymentWithSuccess/>
            )}
          </Row>
        </div>
      </div>
    </div>
  );
};

export default Register;
